import { authSlice } from './authSlice'

export const { getMeRequest, getMeSuccess, getMeFailure } = authSlice.actions
